// extracted by mini-css-extract-plugin
var _1 = "ra-base-header-border";
var _2 = "ra-base-header";
var _3 = "ra-base-header-col-center";
var _4 = "ra-base-header-col";
var _5 = "ra-base-header-col-left";
var _6 = "ra-base-header-col-right";
var _7 = "ra-base-header-col-single";
var _8 = "ra-base-header-row";
var _9 = "ra-base-header-transparent";
export { _1 as "baseHeaderBorderCls", _2 as "baseHeaderCls", _3 as "baseHeaderColCenterCls", _4 as "baseHeaderColCls", _5 as "baseHeaderColLeftCls", _6 as "baseHeaderColRightCls", _7 as "baseHeaderColSingleCls", _8 as "baseHeaderRowCls", _9 as "baseHeaderTransparentCls" }
